import { FC } from 'react';
import { Box, Typography, Grid, SxProps, Theme } from '@mui/material';
import { map } from 'lodash-es';
import { useStyles, clsx } from '../../../../utils/hooks/useStyles';
import { buttonGroupStyles } from './button-group.styles';

export type GroupRadioButtonsType = {
	defaultValue?: string | number;
	selectedItems?: Array<string | number>;
	items: Array<{ name: string; value: string }>;
	sx?: {
		rootSx?: SxProps<Theme>;
		gridItemSx?: SxProps<Theme>;
		buttonBoxSx?: SxProps<Theme>;
		buttonTextSx?: SxProps<Theme>;
		buttonBoxActiveSx?: SxProps<Theme>;
		buttonTextActiveSx?: SxProps<Theme>;
	};
	renderItem?(item: { name: string; value: string }, sx?: SxProps): JSX.Element;
	onChangeHandler?(value: string | number): void;
};

const ButtonsGroup: FC<GroupRadioButtonsType> = ({ items, onChangeHandler, sx = {}, selectedItems, renderItem }) => {
	const styles = useStyles(buttonGroupStyles);

	const renderButton = (item: { name: string; value: string }) => {
		if (renderItem) {
			return renderItem(item, styles.buttonText);
		}

		return <Typography sx={clsx(styles.buttonText, sx.buttonTextSx)}>{item.name}</Typography>;
	};

	return (
		<Grid container spacing={{ xs: 1, s: 2 }} sx={clsx(styles.root, sx.rootSx)}>
			{map(items, (item) => (
				<Grid
					key={item.value}
					onClick={() => {
						onChangeHandler?.(item.value);
					}}
					item
					xs={4}
					lg={3}
					sx={clsx(styles.gridItem, sx.gridItemSx)}
				>
					<Box
						sx={clsx(
							styles.buttonBox,
							sx.buttonBoxSx,
							(selectedItems.includes(item.value)
								? { ...styles.buttonBoxActive, ...sx.buttonBoxActiveSx }
								: {}) as object
						)}
					>
						{renderButton(item)}
					</Box>
				</Grid>
			))}
		</Grid>
	);
};

export default ButtonsGroup;
